import { useCallback, useRef } from "react";

const SIDEBAR_WIDTH_SM = 56;
const SIDEBAR_WIDTH_LG = 208;

interface ChatResizeHandleProps {
  onResize: (width: number) => void;
}

export function ChatResizeHandle({ onResize }: ChatResizeHandleProps) {
  const dragging = useRef(false);

  const onPointerDown = useCallback(
    (e: React.PointerEvent) => {
      e.preventDefault();
      dragging.current = true;
      document.body.style.cursor = "col-resize";
      document.body.style.userSelect = "none";

      const onPointerMove = (ev: PointerEvent) => {
        if (!dragging.current) return;
        const sidebar = window.innerWidth >= 1024 ? SIDEBAR_WIDTH_LG : SIDEBAR_WIDTH_SM;
        const panelWidth = ev.clientX - sidebar;
        onResize(panelWidth);
      };

      const onPointerUp = () => {
        dragging.current = false;
        document.body.style.cursor = "";
        document.body.style.userSelect = "";
        document.removeEventListener("pointermove", onPointerMove);
        document.removeEventListener("pointerup", onPointerUp);
      };

      document.addEventListener("pointermove", onPointerMove);
      document.addEventListener("pointerup", onPointerUp);
    },
    [onResize],
  );

  return (
    <div
      onPointerDown={onPointerDown}
      className="group relative z-10 flex w-3 cursor-col-resize items-center justify-center transition-colors hover:bg-brand-coral/20 active:bg-brand-coral/30"
    >
      <div className="h-10 w-1 rounded-full bg-black/30 transition-colors group-hover:bg-brand-coral dark:bg-white/30 dark:group-hover:bg-brand-coral" />
    </div>
  );
}
